/**
 * Footer Newsletter
 */

const footerSelectors = {
  // ID selectors
  id: {
    newsletterConfirmation: "newsletter-form_confirmation",
    newsletterSubscribeBtn: "Subscribe",
    newsletterMessage: "footer-block-newsletter-error",
    newsletterFooterField: "NewsletterForm--footer",
  },
};

const $newsletterConfirmation = document.getElementById(
  footerSelectors.id.newsletterConfirmation
);
const $newsletterSubscribeBtn = document.getElementById(
  footerSelectors.id.newsletterSubscribeBtn
);
const $newsletterMessage = document.getElementById(
  footerSelectors.id.newsletterMessage
);
const $newsletterFooterField = document.getElementById(
  footerSelectors.id.newsletterFooterField
);

$newsletterFooterField.addEventListener("input", (event) => {
  (event.target.value && $newsletterConfirmation.checked === true) ||
  (event.target.value === "" &&
    ($newsletterConfirmation.checked === true ||
      $newsletterConfirmation.checked === false))
    ? ($newsletterMessage.style.display = "none")
    : ($newsletterMessage.style.display = "flex");
});

$newsletterConfirmation.addEventListener("change", (event) => {
  if (event.target.checked === false && $newsletterFooterField.value) {
    $newsletterSubscribeBtn.setAttribute("disabled", "");
    $newsletterMessage.style.cssText = `
        display: flex;
      `;
  } else {
    $newsletterSubscribeBtn.removeAttribute("disabled", "");
    $newsletterMessage.style.cssText = `
        display: none;
      `;
  }
});
